import {Component, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {
  fetchTasks,
  initialLookupsState,
  Lookups,
  toggleLoading,
  updateUserSettings
} from "../../../redux";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Store} from "@ngrx/store";
import {Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {UserSettingsService} from "../../services";
import {MatDialog} from "@angular/material/dialog";
import {PhoneVerifyModalComponent} from "./phone-verify-modal/phone-verify-modal.component";
import {IUserSettings} from "../../models/i-user-settings";
import {ModalSize, UtilService} from "../../../shared/services/util/util.service";
import {ConfirmationModalComponent, UserCardModalComponent, UserCardSize} from "../../../shared/components";
import { DataService } from 'src/app/services/data/data.service';
import { AuthService, LookupService } from 'src/app/services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent {

  environment = environment;
  config$: Subscription = new Subscription();
  lookups: Lookups = initialLookupsState;
  userSettings: IUserSettings = {} as IUserSettings;
  userCardSize = UserCardSize;
  showPassword: boolean = false;

  //reactive form
  userForm = new FormGroup({
    id: new FormControl(),
    firstName: new FormControl('', Validators.required),
    lastName: new FormControl('', Validators.required),
    jobTitle: new FormControl('', Validators.required),
    companyName: new FormControl('', Validators.required),
    email: new FormControl({value: '', disabled: true}, [Validators.email, Validators.required]),
    emailVerified: new FormControl(false),
    phoneNumberVerified: new FormControl(false),
    mfaType: new FormControl(),
    subId: new FormControl(),
    created: new FormControl(),
    profileLink: new FormControl(),
    imageUrl: new FormControl()
  });

  phoneForm = new FormGroup({
    id: new FormControl(),
    countryCode: new FormControl('+1', Validators.required),
    mobile: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$")])
  });


  changePasswordFormGroup = new FormGroup({
    oldPassword: new FormControl('', Validators.required),
    newPassword: new FormControl('', [Validators.required, this.authService.passwordPatternValidator] ),
  });

  constructor(
    private store: Store,
    private toastr: ToastrService,
    private userSettingsService: UserSettingsService,
    private dialog: MatDialog,
    public util: UtilService,
    private authService: AuthService,
    public lookupService: LookupService,
    private dataService: DataService,
  ) {

    var userSettingsData: IUserSettings | undefined = this.dataService.getAppUser();

    if (userSettingsData != null && userSettingsData != undefined) {
      this.userSettings = userSettingsData;

      this.userForm.patchValue(userSettingsData);
      this.phoneForm.patchValue(userSettingsData);

      console.log("User Settings loaded from DataService", userSettingsData);
    } else {
      this.getUserDataFromApi();
    }
  }

  getUserDataFromApi() {
    this.userSettingsService.getUserSettings().subscribe({
      next: (userSettings: IUserSettings) => {
        this.userSettings = userSettings;
        this.userForm.patchValue(userSettings);
        this.phoneForm.patchValue(userSettings);
      }
    });
  }

  saveUserInfo() {
    this.store.dispatch(toggleLoading({loading: true}));
    this.userSettingsService.updateUserSettings(this.userForm.getRawValue()).subscribe({
      next: (userSettings: any) => {
        this.userForm.patchValue(userSettings);
        this.phoneForm.patchValue(userSettings);
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.success("User Settings Saved!", $localize`:@@companyName:Rondeivu`);
      }, error: error => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.error("Something went wrong!");
      }
    });
  }

  // savePhone() {
  //   this.store.dispatch(toggleLoading({loading: true}));
  //   this.userSettingsService.setPhone(this.phoneForm.getRawValue()).subscribe({
  //     next: (res: any) => {
  //       this.store.dispatch(toggleLoading({loading: false}));
  //       this.toastr.success("Phone 2FA Sent!", $localize`:@@companyName:Rondeivu`);
  //       this.openPhoneVerifyModal();
  //     }, error: error => {
  //       this.store.dispatch(toggleLoading({loading: false}));
  //       this.toastr.error("Something went wrong!");
  //     }
  //   });
  // }

  private openPhoneVerifyModal() {
    this.dialog.open(PhoneVerifyModalComponent, {
      height: 'auto',
      width: this.util.getModalWidth(ModalSize.SMALL),
      disableClose: true,
      data: this.phoneForm.getRawValue()
    })
    .afterClosed().subscribe((result: {id: string, code: string}) => {
      console.log("Dialog closed!", result);
      if (!!result) {
        this.store.dispatch(toggleLoading({loading: true}));
        this.userSettingsService.verifyPhone(result.id, result.code).subscribe({
          next: (res: any) => {
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastr.success("Phone 2FA Verified!", $localize`:@@companyName:Rondeivu`);
            this.store.dispatch({type: fetchTasks});

            // re-get data to update user settings with new phone verification status
            this.getUserDataFromApi();
          }, error: error => {
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastr.error("Invalid 2FA Code!");
          }
        });
      }
    });
  }

  verifyPhone() {
    console.log("Verify Phone", this.phoneForm.getRawValue());
    this.userSettingsService.setPhone(this.phoneForm.getRawValue()).subscribe({
      next: (res: any) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.success("2FA code sent to mobile phone", $localize`:@@companyName:Rondeivu`);
        this.openPhoneVerifyModal();
      }, error: error => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.error("Something went wrong!");
      }
    });
  }

  /**
   * Updates the cognito user password
   */
  changePassword() {
    // check password form
    if (this.changePasswordFormGroup.invalid) {
      this.toastr.error("Please fill all required fields correctly!");
      return;
    }

    var oldPass = this.changePasswordFormGroup.get('oldPassword')?.value || '';
    var newPass = this.changePasswordFormGroup.get('newPassword')?.value || '';

    if (newPass.trim().length != newPass.length) {
      this.toastr.error("New password cannot contain spaces!");
      return;
    }

    this.authService.ChangePassword(oldPass, newPass).subscribe({
      next: () => {
        // reset form and control states
        this.changePasswordFormGroup = new FormGroup({
          oldPassword: new FormControl('', Validators.required),
          newPassword: new FormControl('', [Validators.required, this.authService.passwordPatternValidator] ),
        });
        
      },
      error: (err: any) => {
        console.log("Error changing password", err);
        // reset the form and control states
        this.changePasswordFormGroup = new FormGroup({
          oldPassword: new FormControl('', Validators.required),
          newPassword: new FormControl('', [Validators.required, this.authService.passwordPatternValidator] ),
        });
      }
    });
  }

  openImageUploadModal() {
    this.dialog.open(UserCardModalComponent, {
      height: 'auto',
      width: this.util.getModalWidth(ModalSize.SMALL),
      disableClose: true
    })
    .afterClosed().subscribe(result => {
      console.log("Dialog closed!");
      if (!!result) {
        const uId = this.userForm.get('id')?.value || '';
        const file = new File([result], 'user.png');
        this.userSettingsService.uploadUserImage(file, uId).subscribe({
          next: (res: any) => {
            let url = res.url || ''
            this.userForm.get('imageUrl')?.setValue(url);
            const u = this.userForm.getRawValue() as {} as IUserSettings
            this.store.dispatch(updateUserSettings({user: u}));

            this.toastr.success("Image Uploaded! ", $localize`:@@companyName:Rondeivu`);
          }, error: (err: any) => {
            this.toastr.error("Something went wrong! " + err.message);
          }
        });
      }
    });
  }

  clearImage() {
    this.dialog.open(ConfirmationModalComponent, {
      height: 'auto',
      width: 'auto',
      disableClose: true,
      data: {}
    })
    .afterClosed().subscribe(result => {
      console.log("Dialog closed!");
      if (!!result) {
        const uId = this.userForm.get('id')?.value || '';
        this.userSettingsService.clearUserImage(uId).subscribe({
          next: (res: any) => {
            let url = res.url || ''
            this.userForm.get('imageUrl')?.setValue(url);
            this.toastr.success("Image Cleared! ", $localize`:@@companyName:Rondeivu`);
          }, error: (err: any) => {
            this.toastr.error("Something went wrong! " + err.message);
          }
        });
      }
    });
  }
}
